import React from "react";
import NiceModal, {NiceModalHocProps} from "@ebay/nice-modal-react";
import {useFetchRequest} from "@bounce/shared/helpers";
import {getGuestContributionLink} from "~/api/requests";
import {GenerateContributionLinkContent} from "@bounce/shared/consumer/pages/guest-contribution-link";
import {ContributionLinkResponse} from "@bounce/shared/consumer/declarations";

export interface GenerationContributionLinkDialogProps extends NiceModalHocProps {
  totalBalance: number;
  accountId: string;
}

const GenerateContributionLinkDialog = NiceModal.create(
  ({totalBalance, accountId}: GenerationContributionLinkDialogProps) => {
    const {data, isLoading} = useFetchRequest<ContributionLinkResponse, {accountId: string}>(getGuestContributionLink, {
      accountId,
    });

    if (!data) return null;
    return <GenerateContributionLinkContent data={data} isLoading={isLoading} totalBalance={totalBalance} />;
  }
);

export default GenerateContributionLinkDialog;
